import type { FieldMergeFunction } from '@apollo/client'

const merge: FieldMergeFunction<Mortgage[]> = (existing, incoming) => {
  return incoming
}

export default {
  merge,
}
